export default __webpack_public_path__ + "static/media/checked.6d2f7a9a.svg";